import {
  ApplicationInsights,
  type ITelemetryItem,
} from '@microsoft/applicationinsights-web';

const GTMDomains = [
  'gstatic.com',
  'google-analytics.com',
  'googletagmanager.com',
];

const isGTMFailingQuickly = (req: ITelemetryItem) => {
  // NOTE: Removes uneccesary error logging of GTM when the connection is cut early (less then a second) due to ex. user using adblockers
  if (req.baseType !== 'RemoteDependencyData') {
    return false;
  }
  const { target, duration, success } = req.baseData ?? {};
  return (
    success === false &&
    duration < 1000 &&
    GTMDomains.some(domain => target.includes(domain))
  );
};

export type TrackExceptionProperties = NonNullable<
  Parameters<ApplicationInsights['trackException']>[1]
>;

let appInsights: ApplicationInsights | undefined;

const toError = (error: unknown): Error => {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === 'string') {
    return new Error(error);
  }

  return new Error('Unknown client error');
};

export const initiateApplicationInsights = (connectionString: string) => {
  appInsights = new ApplicationInsights({
    config: {
      connectionString,
    },
  });

  appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer(req => !isGTMFailingQuickly(req));
  appInsights.trackPageView();
};

export const trackCustomException = (
  error: unknown,
  properties: TrackExceptionProperties = {}
) => {
  appInsights?.trackException(
    {
      exception: toError(error),
    },
    properties
  );
};
